import { MutationTree } from 'vuex'
import { State } from '.'

const mutations: MutationTree<any> = {
	'setLoginError'(state, payload: false | string) {
		state.loginError = payload
	},
	'setLoginMessage'(state, payload: false | string) {
		state.loginMessage = payload
	},
	'setPreventNavigation'(state, payload: {prevent: boolean, message?: string}) {
		state.preventNavigation = payload
	}
}

export default mutations
